/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-key */
import React from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Button, Col, List, Row } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';
import { APPOINTMENTS_MESSAGES, getAppointmentsConfig } from '../../../../../../services/appointments';
import { convertMessageTemplate } from '../../../../../../utils/convertMessageTemplate';

export const AppointmentMessages = () => {
  const { data: config, isFetching } = useQuery(
    'appointmentConfig',
    async () => {
      try {
        const response = await getAppointmentsConfig();
        const configArray = APPOINTMENTS_MESSAGES.map(msg => {
          if (['updated'].includes(msg.id)) {
            return {
              ...msg,
              message: msg.defaultMessage || '',
              enabled: true,
            };
          }
          const existingConfig = response[msg.id] || {};
          return {
            ...msg,
            message: existingConfig.messageTemplate || msg.defaultMessage || '',
            enabled: msg.id === 'confirmation' ? true : existingConfig.enabled || false,
          };
        });
        return configArray;
      } catch (e) {
        console.error('Error fetching appointment config:', e);
        return [];
      }
    },
    {
      refetchOnWindowFocus: false,
      initialData: [],
    },
  );

  return (
    <SettingsContent title="Messages">
      <List
        header={<AppointmentConfigHeader />}
        className="w-100-P m-btm-16"
        size="small"
        dataSource={config}
        renderItem={item => <AppointmentConfigItem item={item} />}
        loading={isFetching}
      />
    </SettingsContent>
  );
};

const AppointmentConfigHeader = () => {
  return (
    <Row justify="space-between" align="middle" style={{ width: '100%' }}>
      <Col span={4}>
        <HeaderItem name="Name" />
      </Col>
      <Col span={2}>
        <HeaderItem name="Timing" />
      </Col>
      <Col span={12}>
        <HeaderItem name="Message" />
      </Col>
      <Col span={2} />
    </Row>
  );
};

const HeaderItem = ({ name }) => {
  return (
    <div className="flex-row p-left-6" style={{ color: '#0000006B' }}>
      {name}
    </div>
  );
};

const ContentItem = ({ content }) => {
  return <div className="flex-row ">{content}</div>;
};

const AppointmentConfigItem = ({ item }) => {
  const { push } = useHistory();
  return (
    <List.Item style={{ margin: 0 }} styles={{ actions: { margin: 0 } }} key={item.id}>
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        <Col span={4}>
          <ContentItem content={item.name} />
        </Col>
        <Col span={2}>
          <ContentItem content={item.timing} />
        </Col>
        <Col span={12}>
          <ContentItem
            content={
              <div
                style={{ textAlign: 'left' }}
                dangerouslySetInnerHTML={{ __html: convertMessageTemplate(item.message) }}
              />
            }
          />
        </Col>
        <Col span={2}>
          <div className="flex-row items-end w-100-P justify-end">
            <Button
              onClick={() => push(`/Configuration/appointments/messages/${item.id}`)}
              variant="text"
              color="primary"
              htmlType="button"
              className="m-right-8"
              disabled={item.id === 'updated'}
            >
              Edit
            </Button>
          </div>
        </Col>
      </Row>
    </List.Item>
  );
};
